<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          landscapeMode
          :merge="grid.merge"
          :columns="grid.columns"
          :data="grid.data"
          :gridHeightAuto="true"
          :editable="editable && !disabled"
          :columnSetting="false"
          :filtering="false"
          :usePaging="false"
          @headerDataChange="headerDataChange"
        >
          <template slot="suffixTitle">
            <font class="text-negative" color="red"  style="font-size:0.8em;font-weight:300;">
              <q-icon name="radio_button_unchecked" color="red"  class="text-black"/>정상
              <q-icon name="close" color="red" class="text-black"/>이상
              <q-icon name="circle" color="red" class="text-black"/>청소
              V교환
              <q-icon name="check_box_outline_blank"  color="red" class="text-black"/>마모
              △누유
              ▲필요
              <!-- <q-icon name="warning_amber" class="text-black"/> : Oil 누유 &nbsp;
              <q-icon name="warning" class="text-black"/> : 점검필요 &nbsp; -->
              <q-icon name="radio_button_checked" color="red"  class="text-black"/>비가동
            </font>
          </template>
          <template slot="table-select">
            <c-select
              v-if="editable && !disabled"
              :comboItems="dateItems"
              type="custom"
              typetxt="일자선택"
              itemText="dayName"
              itemValue="dayCode"
              name="today"
              label=""
              v-model="today"
              @datachange="datechange"
            ></c-select>
          </template>
          <template slot="table-button">
            <q-btn-group>
              <c-btn
                v-if="editable && !disabled && !data.sysApprovalRequestId"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="data.deteriorCheckId ? this.grid.data : this.data"
                mappingType="POST"
                label="저장"
                icon="save"
                @beforeAction="saveData"
                @btnCallback="saveCallback" />
            </q-btn-group>
          </template>
          <template v-slot:customArea="{ props, col }">
            <template v-if="col.name === 'remark'">
              <c-text
                :editable="editable"
                :props="props"
                :col="col"
                :disabled="disabled"
                v-model="props.row['remark']"
                @dataChange="datachange1(props)"
              />
            </template>
            <template v-else>
              <c-select
                stype="tableselect"
                :editable="editable"
                :comboItems="checkboxItems"
                itemText="codeName"
                itemValue="code"
                type="edit"
                label=""
                name="checkItems"
                v-model="props.row[col.name]"
                @datachange="datachange2(props)"
              >
              </c-select>
            </template>
          </template>
        </c-table>
      </div>  
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import transactionConfig from '@/js/transactionConfig';
import mobileConfig from '@/js/mobileConfig';
import mixinCommon from '@/js/mixin-page-common'
export default {
  name: 'equipment-deterior-result',
  mixins: [mixinCommon],
  props: {
    data: {
      type: Object,
      default: () => ({
        deteriorCheckId: '',  // 열화점검 일련 번호
        plantCd: '',  // 사업장 코드
        checkStatusCd: '',  // 계획수립/점검중/점검완료
        lineId: '',  // 라인일련번호
        checkDeptCd: '',  // 점검부서
        checkUserId: '',  // 점검자 ID
        checkDate: '',  // 점검월
        deteriorName: '',  // 점검명
        evaluationCompleteFlag: 'N',  // 결재완료 후 평가완료 처리
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드
        utilityFlag: 'N',
        deteriorResultModelList: [], // sheet
        deteriorImproveModelList: [], 
      }),
    },
    grid: {
      type: Object,
      default: () => ({
        height: 'auto',
        columns: [],
        data: [],
      }),
    },
    dateItems: {
      type: Array,
      default: () => [],
    },
    eventScroll: {
      type: Object,
      default(){
        return {
          position: null,
          direction: null,
          save: null,
          isSave: false,
        }
      },
    },
  },
  data() {
    return {
      year: '',
      popupOptions: {
        isFull: true,
        // width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      updateMode: false,
      editable: true,
      saveUrl: transactionConfig.sop.min.equipment.plan.deterior.insert.url,
      insertUrl: '',
      updateUrl: '',
      isSave: false,
      isComplete: false,
      isApproval: false,
      mappingType: 'POST',
      currentMonth: '',
      lunarHolidays: [],
      today: '',
      checkboxItems: [
        // { code: null, codeName: ''},
        { code: 'CHK001', codeName: 'o'},
        { code: 'CHK002', codeName: 'X'},
        { code: 'CHK003', codeName: '●'},
        { code: 'CHK004', codeName: 'V'},
        { code: 'CHK005', codeName: '□'},
        { code: 'CHK006', codeName: '△'},
        { code: 'CHK007', codeName: '▲'},
        { code: 'CHK008', codeName: '⊙'},
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    disabled() {
     return this.data.checkStatusCd === 'MCSC000015' || Boolean(this.data.sysApprovalRequestId)
    },
    mobileSave() {
      return {
        bol: this.editable && !this.disabled && !this.data.sysApprovalRequestId,
        uid: uid(),
      }
    },
  },
  watch: {
    'eventScroll.save'() {
      this.saveData();
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;

      this.today= this.$comm.getToday().slice(-2, this.$comm.getToday().length);
      this.currentMonth= this.$comm.getToday().slice(-5, this.$comm.getToday().length -3);
      if (String(this.today.charAt(0)) === '0') {
        this.today = this.today.substring(1)
      }
      // url setting
      this.getUrl = mobileConfig.sop.min.equipment.plan.deterior.get.mobile.url;
      this.insertUrl = transactionConfig.sop.min.equipment.plan.deterior.insert.url;
      this.updateUrl = transactionConfig.sop.min.equipment.result.deterior.newItem.url;
      // code setting
      // list setting
    },
   
    saveData() {
      if (this.data.deteriorCheckId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.data.regUserId = this.$store.getters.user.userId;
          this.data.chgUserId = this.$store.getters.user.userId;

          this.$_.forEach(this.grid.data, _item => {
            _item.regUserId = this.$store.getters.user.userId;
            _item.chgUserId = this.$store.getters.user.userId;
            if (!_item['day'+this.today]) {
              this.$set(_item, 'day'+this.today, _item.remark)
            }
          })

          if (this.mappingType === 'POST') {
            this.$_.forEach(this.grid.data, _item => {
              this.$_.forEach(this.grid.data, __item => {
                if(__item.deteriorCheckResultId === _item.deteriorCheckResultId) {
                  __item = _item;
                }
              })
            })
          } else if (this.mappingType === 'PUT') {
            this.grid.data = this.$_.clone(this.grid.data);
          } 

          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.mappingType === 'POST') {
        this.data.deteriorCheckId = result.data
        this.returnData.col1 = result.data
        this.$_.forEach(this.grid.data, _item => {
          _item.deteriorCheckId = result.data;
          _item.editFlag = 'U';
        })
      }
    },
    datachange2(props) {
      props.row['remark'] = null;
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    datachange1(props) {
      props.row['day' + this.today] = null;
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    headerDataChange(props, col) {
      if (col.name === String('day' + this.today)) {
        this.$_.forEach(this.grid.data, _item => {
          _item.remark = '';
        })
      } else if (col.name === 'remark') {
        this.$_.forEach(this.grid.data, _item => {
          this.$set(_item, String('day' + this.today), null)
        })
      }
    },
    datechange() {
      this.$emit('setToday', this.today);
    }
  }
};
</script>
